(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dpd-danawharf-activities"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var containers = document.querySelectorAll('.dpd-dw-carousel-container');
    containers.forEach(function (container) {
      var scroll = container.querySelector('.dpd-dw-scroll');
      var prev = container.querySelector('.dpd-dw-arrow--prev');
      var next = container.querySelector('.dpd-dw-arrow--next');
      if (!scroll || !prev || !next) return;

      var cardWidth = function () {
        var card = scroll.querySelector('.dpd-dw-card');
        return card ? card.offsetWidth + 20 : 340;
      };

      prev.addEventListener('click', function () {
        scroll.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        scroll.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });

      function updateArrows() {
        prev.style.opacity = scroll.scrollLeft <= 10 ? '0.3' : '1';
        prev.style.pointerEvents = scroll.scrollLeft <= 10 ? 'none' : 'auto';
        var atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 10;
        next.style.opacity = atEnd ? '0.3' : '1';
        next.style.pointerEvents = atEnd ? 'none' : 'auto';
      }
      scroll.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
